import Player from '@vimeo/player';

export default function HeroEmbed() {
  const videoDiv = document.getElementById('borghetti-reel');
  const vimeoId = videoDiv.getAttribute("data-load-video-id");

  const options = {
    id: vimeoId,
    loop: true,
    muted: true,
    autoplay: true,
    title: false,
    byline: false,
    portrait: false,
    background: true
  }

  new Player("borghetti-reel", options);
}